import React, { useEffect, useState, useContext } from "react";
import { Toolbar } from "@mui/material";
import { DataGridComponent } from "../../Components/PaginationComponent";
import PeopleAltOutlinedIcon from "@mui/icons-material/PeopleAltOutlined";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import APIServices from "../../services/APIServices";
import ButtonCompo from "../../Components/ButtonComponent/ButtonCompo";
import { useDispatch } from "react-redux";
import { EnvironmentContext } from "../../EnvironmentContext";
import apiconfig from "../../config/config";
import { setAccessToken } from "../../Redux/Actions";

const OrganiserManagement = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch()
  const { environment } = useContext(EnvironmentContext)
  const [isLoading, setIsLoading] = useState(false);
  const [totalCount, setTotalCount] = useState(0);
  const [appliedUsers, setAppliedUsers] = useState([])
  const allOrganisersCount = useSelector((state) => state.totalOrganiserCount);
  const accessToken = useSelector((state) => state.accessToken);


  useEffect(() => {
    if (typeof window !== "undefined") {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }, []);

  useEffect(() => {
    const tokenLocal = JSON.parse(localStorage.getItem("token"));

    if (!accessToken && tokenLocal) {
      dispatch(setAccessToken(tokenLocal));
      APIServices.setAuthToken(tokenLocal);
    } else if (!accessToken && !tokenLocal) {
      navigate("/login");
    }

    if (accessToken || tokenLocal) {
      const tokenToUse = accessToken || tokenLocal;
      APIServices.setAuthToken(tokenToUse);
      setIsLoading(true);

      const url =
        environment === "Production"
          ? apiconfig.production.apiBaseUrl
          : apiconfig.develpoment.apiBaseUrl;

      APIServices.setApiBaseUrl(url);
      APIServices.usersFormVerified()
        .then((res) => {
          // console.log("res.data:", res.data)
          setIsLoading(false)
          setTotalCount(res.data.Count)
          setAppliedUsers(res.data.Users)
        })
        .catch((err) => {
          setIsLoading(false)
          alert("Getting error while fetching data , please try after sometime")
          console.log(err)
        })


    }
  }, [dispatch, environment, accessToken, navigate]);

  const columns = [
    {
      field: "profileId",
      headerName: "Profile ID",
      width: 150,
      cellClassName: (params) => params.row.orgViewed ? 'orgViewed' : 'notViewd',
      headerClassName: "custom-header",
      renderCell: (params) => (
        <Link
          to={`/customer/${params.value}`}
          style={{ color: "#0B63F8", fontFamily: "poppins" }}
        >
          {params.value}
        </Link>
      ),
    },
    {
      field: "FullName",
      headerName: "Full Name",
      width: 250,
      cellClassName: (params) => params.row.orgViewed ? 'orgViewed' : 'notViewd',
      headerClassName: "custom-header",

    },
    {
      field: "email",
      headerName: "Email ID",
      width: 250,
      cellClassName: (params) => params.row.orgViewed ? 'orgViewed' : 'notViewd',
      headerClassName: "custom-header",
    },
    {
      field: "OrganiserStatus",
      headerName: "Organiser status",
      width: 200,
      cellClassName: (params) => params.row.orgViewed ? 'orgViewed' : 'notViewd',
      // cellClassName: "organiser-status-cell",
      headerClassName: "custom-header",
    },
    {
      width: 150,
      display: "flex",
      alignItems: "center",
      cellClassName: (params) => params.row.orgViewed ? 'orgViewed' : 'notViewd',
      renderCell: (params) => (
        <ButtonCompo btnText='View details' btnOutlined onClick={() => handleButtonClick(params.row)} />
      ),
    },
  ];

  const rows = appliedUsers.map((item, index) => ({
    id: index,
    profileId: item?.profile_id,
    FullName: `${item?.firstName} ${item?.lastName}`,
    email: item?.email,
    OrganiserStatus: item?.form_verification,
    user_id: item?._id,
    orgViewed: item?.org_request_viewed
  }));

  const handleButtonClick = (row) => {
    navigate(`/organiser-management/Viewedit/${row.user_id}`);
  };

  return (
    <div className="organisermanagement-cont-padding">

      <div className="travellers-org-container">
        <div className="travellers-org">
          <PeopleAltOutlinedIcon
            style={{
              width: "34px",
              height: "34px",
              color: "#059669",
            }}
          />
          <div className="travells-cont">
            <p className="total-users-para">Total applications</p>
            <h3 className="total-users-heading">{totalCount} </h3>
          </div>
        </div>

        <div className="travellers-org">
          <PeopleAltOutlinedIcon
            style={{
              width: "34px",
              height: "34px",
              color: "#059669",
            }}
          />
          <div className="travells-cont">
            <p className="total-users-para">Total organisers</p>
            <h3 className="total-users-heading">{allOrganisersCount} </h3>
          </div>
        </div>
      </div>
      <main style={{ flexGrow: 1 }}>
        <Toolbar />
        <DataGridComponent columns={columns} rows={rows} isLoading={isLoading} rowCount={totalCount} />
        {/* <PaginationComponent
          columns={columns}
          rows={rows}
          isLoading={isLoading}
          paginationModel={paginationModel}
          paginationMeta={{ hasNextPage }}
          onPaginationModelChange={handlePaginationModelChange}
          rowCount={totalCount}
        /> */}
      </main>
    </div>
  );
};

export default OrganiserManagement;
